// extracted by mini-css-extract-plugin
export default {"auctioneer-property-info":"g__auctioneer-property-info--fxAVl"};